// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    DirectionsBusIcon
}

const transportistas = {
    id: 'transportistas',
    title: '',
    type: 'group',
    children: [
        {
            id: 'transportistas_menu',
            title: 'Transportistas',
            type: 'collapse',
            icon: icoMenu.DirectionsBusIcon,
            children: [
                {
                    id: 'crear_transportistas',
                    title: 'Crear Transportista',
                    type: 'item',
                    url: '/user/new-transportistas/0'
                },
                {
                    id: 'lista_transportistas',
                    title: 'Lista Transportistas',
                    type: 'item',
                    url: '/user/list-transportistas-view'
                },
            ]
        },
    ]
};

export default transportistas;
